import React from "react";

import useUserDefaultCurriculumQuery from "./useUserDefaultCurriculumQuery";

export default function useHasDefaultCurriculumAccessQuery() {
  const {
    userDefaultCurriculum,
    isUserDefaultCurriculumLoading,
    userDefaultCurriculumError,
  } = useUserDefaultCurriculumQuery();

  const hasDefaultCurriculumAccess = React.useMemo(() => {
    if (isUserDefaultCurriculumLoading || userDefaultCurriculumError) {
      return undefined;
    }

    return Boolean(userDefaultCurriculum);
  }, [
    userDefaultCurriculum,
    isUserDefaultCurriculumLoading,
    userDefaultCurriculumError,
  ]);

  return {
    hasDefaultCurriculumAccess,
    isHasDefaultCurriculumAccessLoading: isUserDefaultCurriculumLoading,
    hasDefaultCurriculumAccessError: userDefaultCurriculumError,
  };
}
